<div class="loaderMain" *ngIf="!isLoading">
    <div class="loader" ></div>
  </div>